/**
 * The one list of currencies the app supports, and their symbols.
 *
 * Kept in a single module because the symbol map used to be copy-pasted into
 * every page and modal that prints money: adding a currency meant finding all
 * seven copies. Must stay in step with `access.SUPPORTED_CURRENCIES` on the
 * server, which is what actually validates a sheet's currency.
 *
 * CAD is "C$", not "$", so a Canadian amount can't be misread as a US one on a
 * screen showing both.
 */
export const CURRENCIES = [
  { code: "USD", symbol: "$" },
  { code: "EUR", symbol: "€" },
  { code: "CAD", symbol: "C$" },
];

export const CURRENCY_SYMBOLS = Object.fromEntries(
  CURRENCIES.map((c) => [c.code, c.symbol])
);

/** The symbol for a currency code, falling back to "$" for anything unknown. */
export const symbolFor = (code) => CURRENCY_SYMBOLS[code] || "$";
